import { TRACK_CONTENT_SOURCE_CLICKED_EVENT, TRACK_SOURCE_CONNECTED_EVENT, TRACK_SOURCE_TYPE_SELECTED_EVENT } from "src/constants/adoption/eventTypes";
import { useTrackEventForAdoption } from "src/query/adoption";
import { SourceTypeConnected, SourceTypeSelected } from "src/types/adoption/settings/dataSource";
import { SettingsModule } from "src/types/settings/common";

export const useSourceTracking = () => {
  const { mutate: trackEvent } = useTrackEventForAdoption(SettingsModule.CONTENT_SOURCES);

  const trackSourceTypeSelected = ({ sourceType }: SourceTypeSelected) => {
    trackEvent({
      event: TRACK_SOURCE_TYPE_SELECTED_EVENT,
      properties: {
        source_type: sourceType,
      },
    });
  };

  const trackSourceConnected = ({ sourceType }: SourceTypeConnected) => {
    trackEvent({
      event: TRACK_SOURCE_CONNECTED_EVENT,
      properties: {
        source_type: sourceType,
      },
    });
  };

  const trackContentSourceClicked = () => {
    trackEvent({
      event: TRACK_CONTENT_SOURCE_CLICKED_EVENT,
      properties: {},
    });
  };

  return {
    trackSourceTypeSelected,
    trackSourceConnected,
    trackContentSourceClicked
  };
};